import React, { useState } from 'react';
import { Form, FormInstance, Input, Typography } from 'antd';
import { NameOf } from 'src/utils';
import  DataLinkInfoDTO from '../models/generated/DataLinkInfoDTO';

export interface DataLinkInfoFormProps {
    form: FormInstance<any>;
}
const DataLinkInfoForm: React.FC<DataLinkInfoFormProps> = ({ form }) => {

    //const [form] = Form.useForm();
    const layout = {
        labelCol: { span: 14 },
        wrapperCol: { span: 10 },
    };
    return (
        <Form
            {...layout}
            labelWrap={true }
            name='dataLinkInfoForm'
            colon={false}
            disabled={true}
            layout='horizontal'
            form={form}
        >
            <fieldset>
                <legend>Data Link Information</legend>
                <Form.Item label={<Typography.Text strong>Agent Initialized Connection</Typography.Text>}
                    name={NameOf<DataLinkInfoDTO>('agentInitalizedConnection')}
                >
                    <Input></Input>
                </Form.Item>
                <Form.Item label={<Typography.Text strong>Agent Initialized Accounting Link Configuration</Typography.Text>}
                    name={NameOf<DataLinkInfoDTO>('agentInitalizedAccountingLinkConfig')}
                >
                    <Input></Input>
                </Form.Item>
                <Form.Item label={<Typography.Text strong>Agent Initialized Transactions</Typography.Text>}
                    name={NameOf<DataLinkInfoDTO>('agentInitalizedTransactions')}
                >
                    <Input></Input>
                </Form.Item>
                <Form.Item label={<Typography.Text strong>Agent Completed Refresh</Typography.Text>}
                    name={NameOf<DataLinkInfoDTO>('agentLastCompletedRefresh')}
                >
                    <Input></Input>
                </Form.Item>
                <Form.Item label={<Typography.Text strong>Agent Completed Batch</Typography.Text>}
                    name={NameOf<DataLinkInfoDTO>('agentLastCompletedBatchUpdate')}
                >
                    <Input></Input>
                </Form.Item>
            </fieldset>
        </Form>
    );
	
};

export default DataLinkInfoForm;